
const ninemax = 9
function StrRunner (run) {
  if(run[0] && run[1] && run[2])return '満塁'
  if(run[0] + run[1] + run[2] == 0)return '無し'
  let str = ''
  if(run[0])str += '一'
  if(run[1])str += '二'
  if(run[2])str += '三'
  return str + '塁'
}
const Xors = require('./xorshift.js').Xorshift;
// 実行
//exports.GameMain = function(Nine, rrchange, rep_bat = null, seed=null) {
function GameMain(Nine, rrchange, SH_Flag, rep_bat = null, seed=null) {
  const xors = new Xors();
  let nowjun = 0
  let Runner = '0 000'
  let Ining
  let event = new Array ()
  const eventlist = ['SING', 'SEC', 'THI', 'HR', 'BB', 'HBP', 'SO', 'OUT']
  function GetRand () {
    if (seed) {
      const ran = xors.rnd()
      return (ran % 10000) / 10000
      //return random.nextfloat();
    }else{
      return Math.random();
    }
  }
  function Omosa(a) {
    let sum = 0
    let array = Object.keys(a)
    array.some(key =>{
      sum += a[key]
    })
    let r = GetRand() * sum
    let ff = 0
    let retkey = null
    array.some(key =>{
      ff += a[key];
      if (r < ff) { 
        retkey = key
        return true 
      }
    })
    if(retkey)return retkey;else
    return array[array.length - 1]
  }
  function calcPSNT(p) { 
    return(p > 0 && GetRand() <= p);
  }
  
  function GameStart() {
    if(seed)xors.seed(seed)
    Ining = 0
    nowjun = 0
    IningChange()
  }
  /*function ExchangeRunOut(out, runner = null) {
    if (runner == null) {
      const res = out.split(' ')
      return {out: Number(res[0]), run: [Number(res[1][0]), Number(res[1][1]), Number(res[1][2])]}
    }else{
      return (out + ' ' + runner[0] + runner[1] + runner[2])
    }
  }*/
  function IningChange () {
    if(Ining == 8 && calcPSNT(0.08) || Ining >= 9)return true
    Runner = '0 000'
    Ining =Ining + 1;
    return false
  }
  GameStart()
  function Pitch() {
    if(SH_Flag && Nine[nowjun].SH_play && Runner in Nine[nowjun].SH_out
        && Nine[nowjun].SH_out[Runner] 
        && (Nine[nowjun].SH_plan >= 100 || calcPSNT(Nine[nowjun].SH_plan / 100))) {
      if(Nine[nowjun].SH_rate >= 100 || calcPSNT(Nine[nowjun].SH_rate / 100)) {
        return 'SH'
      }else{
        return 'SH_out'
      }
    }else{
        let result_hi = {}
        eventlist.some(e =>{
          result_hi[e] = Nine[nowjun][e]
        })
        return Omosa(result_hi)
    }
  }
  //ここからメイン処理
  for(let mugen = 0;mugen < 100000; mugen=(mugen+1)|0){
    //const jokyo = OutCount + '死' + StrRunner(Runner)

    let result = Pitch()
    if(result == 'SH_out') {
      result = 'OUT'
      switch(Runner) {
        case '0 100': case '0 010':
          Runner = '1 100'; break;
        case '0 110':
          Runner = '1 110'; break;
        case '1 100': case '1 010': 
          Runner = '2 100'; break;
        case '1 110': 
          Runner = '2 110'; break;
      }
    }else{
      Runner = Omosa(rrchange[result][Runner])
    }
     
    const OutCount = Number(Runner.slice( 0, 1 ));

    
    event.push({ining: Ining, jun: nowjun, result: result, runner: Runner})
    nowjun += 1
    if(nowjun >= 9)nowjun = 0
    if (OutCount >= 3) {
      if(IningChange()) {
        return event 
      }
    }
  }
}
export default {GameMain}


// WEBPACK FOOTER //
// ./src/components/gamescript/simmain.js